import { AfterViewInit, Component, Inject, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { MapCoordinates, RealtimeFacade } from '@ridango/components';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent, WebSocketService } from '@ridango/core';
import Env from '@ridango/core/env';
import { DOCUMENT } from '@angular/common';

@Component({
    template: ` <rwidget-map
        class="map-full"
        [latitude]="mapCenter.latitude"
        [longitude]="mapCenter.longitude"
        (mapReady)="onMapReady()">
        <rwidget-map-layer-group [label]="'SCHEDULE_BUSES_LAYER' | translate">
            <rwidget-map-marker
                *ngFor="let bus of busLocations$ | async"
                [latitude]="bus.latitude"
                [longitude]="bus.longitude">
                <rwidget-map-icon [anchor]="[17, 17]" [size]="[34, 34]">
                    <rwidget-map-bus-icon [bus]="bus"></rwidget-map-bus-icon>
                </rwidget-map-icon>
            </rwidget-map-marker>
        </rwidget-map-layer-group>
    </rwidget-map>`,
    styleUrls: ['./map-page.component.scss']
})
export class MapPageComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
    public mapCenter: MapCoordinates = this.env.MAP.COORDINATES;
    public busLocations$ = this.realtime.locations$;

    constructor(
        @Inject('ENV') public env: Env,
        @Inject(DOCUMENT) private document: Document,
        private webSocket: WebSocketService,
        private zone: NgZone,
        private realtime: RealtimeFacade,
        private renderer: Renderer2
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscribeRealtimeBusLocations();
    }

    ngAfterViewInit(): void {
        this.renderer.removeClass(this.document.body, 'no-margin');
    }

    private subscribeRealtimeBusLocations() {
        this.zone.runOutsideAngular(() => {
            this.webSocket
                .connect(this.env.REALTIME_VEHICLE_STATUS_PATH)
                .pipe(takeUntil(this.componentDestroyed$))
                .subscribe((buses) => {
                    this.realtime.setLocations(buses);
                });
        });
    }

    public onMapReady() {
        this.webSocket.send({
            regionId: this.env.REALTIME_REGION_ID || this.env.REGION_ID,
            topLeftCoordinates: {
                longitude: 0,
                latitude: 180
            },
            bottomRightCoordinates: {
                longitude: 180,
                latitude: -180
            }
        });
    }
}
